module.exports = __webpack_public_path__ + "static/media/logoDiftransparente.470ff5b5.jpeg";